import { render, staticRenderFns } from "./Beta.vue?vue&type=template&id=2edbd9de&scoped=true&"
import script from "./Beta.vue?vue&type=script&lang=js&"
export * from "./Beta.vue?vue&type=script&lang=js&"
import style0 from "./Beta.vue?vue&type=style&index=0&id=2edbd9de&lang=scss&scoped=true&"
import style1 from "./Beta.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbd9de",
  null
  
)

export default component.exports